<template>
    <div class="w-100">
        <div class="sollicita-compraconcluida text-center">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-12">
                        <h3>{{title}}</h3>
                        <p class="mt-3 mb-0">{{description}}</p>
                        <p class="mb-0">{{description2}}</p>
                        <img class="mt-3" :src="img" />
                        <p class="mt-3 mb-0">{{msg}}</p>

                        <router-link class="btn btn-yellow btn-ok my-5" :to="{name:'MeusCursos'}">
                            ok
                        </router-link>
                    </div>

                </div>
            </div>


        </div>
    </div>
</template>

<script>
    import smile from '@/assets/img/smile.svg';

    export default {
        components: {
        },
        props: {
            title: {
                type: String,
                default: 'Compra Concluída!'
            },
            description: {
                type: String,
                default: 'Agradecemos pelo compra, seus itens estão agora disponíveis em sua conta.'
            },
            description2: {
                type: String,
                default: 'Sempre que necessário estaremos á disposição.'
            },
            msg: {
                type: String,
                default: 'Você receberá um e-mail com mais informações sobre sua compra.'
            },
            img: {
                type: String,
                default: smile
            },
        },
        methods: {
        },
    }
</script>


<style lang="scss">
    .sollicita-compraconcluida {
        h3 {
            font-family: Rounded Mplus 1c Bold;
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            color: #163142;
        }

        p {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            color: #1D4056;
        }

        .btn-ok {
            width: 10em;
        }
    }
</style>